import React from 'react'
import PropTypes from 'prop-types'

import { ITEM_KINDS } from './constants'
import {
  DropdownItem,
  DropdownLink,
  DropdownPanel,
  DropdownPositioner,
  DropdownWrapper,
  SectionLabel,
  TabSlot,
} from './component.styles'

const ProgramNavDropdown = ({
  children,
  isOpen,
  items,
  label,
  onBlur,
  onFocus,
  onItemClick,
  onKeyDown,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onTabClickCapture,
  panelId,
  positionerRef,
  tabSlotRef,
  wrapperRef,
}) => (
  <DropdownWrapper
    onBlur={onBlur}
    onFocus={onFocus}
    onKeyDown={onKeyDown}
    onMouseDown={onMouseDown}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    ref={wrapperRef}
  >
    <TabSlot onClickCapture={onTabClickCapture} ref={tabSlotRef}>
      {/* Disclosure pattern: aria-haspopup is omitted because it implies an
          ARIA menu with arrow-key navigation, which this panel does not have. */}
      {React.isValidElement(children)
        ? React.cloneElement(children, {
            'aria-controls': isOpen ? panelId : undefined,
            'aria-expanded': isOpen,
          })
        : children}
    </TabSlot>
    {isOpen && (
      <DropdownPositioner ref={positionerRef}>
        <DropdownPanel
          aria-label={`${label} menu`}
          data-testid="program-nav-dropdown"
          id={panelId}
        >
          {items.map((item, index) => {
            const key = `${item.kind}-${item.title}-${index}`

            if (item.kind === ITEM_KINDS.sectionLabel) {
              return <SectionLabel key={key}>{item.title}</SectionLabel>
            }

            return (
              <DropdownItem key={key}>
                <DropdownLink
                  dataTestId={`program-nav-dropdown-link-${index}`}
                  href={item.route}
                  isActive={item.isSelected || false}
                  onClick={event => onItemClick(event, item.route)}
                  target="_self"
                >
                  {item.title}
                </DropdownLink>
              </DropdownItem>
            )
          })}
        </DropdownPanel>
      </DropdownPositioner>
    )}
  </DropdownWrapper>
)

ProgramNavDropdown.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.oneOf(Object.values(ITEM_KINDS)).isRequired,
      title: PropTypes.string.isRequired,
      route: PropTypes.string,
      isSelected: PropTypes.bool,
    }),
  ).isRequired,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onItemClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onTabClickCapture: PropTypes.func,
  panelId: PropTypes.string,
  positionerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  tabSlotRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  wrapperRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

export default ProgramNavDropdown
